import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "../../utils/router";

import { auth } from "../../utils/auth";
import { getLink, getSucursal, permisions } from "../../utils/helpers";
import { request } from "../../utils/request";

const MobileHeader = ({ abrirSidebar = () => {} }) => {
	const [sucursalActual, setSucursalActual] = useState(getSucursal());
	const [showMenu, setshowMenu] = useState(false);
	const [showSucursales, setshowSucursales] = useState(false);

	let history = useHistory();

	function toggleMenu() {
		setshowMenu(!showMenu);
	}

	// El drawer lo controla Dashboard; aquí sólo se pide que se abra.
	function abrirMenuLateral() {
		setshowMenu(false);
		abrirSidebar();
	}

    function toggleSucursales() {
        setshowSucursales(!showSucursales);
    }

	const setSucursal = async (sid) => {
        try {
            const res = await request("sset?sid=" + sid);

            if (res.success) {
                for (var i = 0; i < localStorage.length; i++) {
                    if (localStorage.key(i) !== 'user') {
                        localStorage.removeItem(localStorage.key(i));
                    }
                }

                window.localStorage.setItem("sucursalActual", res.data.id);
                window.localStorage.setItem("config", JSON.stringify(res.data.config));
                setSucursalActual(res.data.id);
                history.push("/" + res.data.id);
				window.location = "/" + res.data.id;
            } else {
                console.error("Error al cambiar de sucursal:", res.error);
            }
        } catch (error) {
            console.error("Error al cambiar de sucursal:", error);
        }
    };
	const handleConfiguracionClick = () => {
        setshowMenu(false);
	}
    const usuario = auth.getUser();
    const sucursalActualData = usuario.sucursales.find(s => s.id === parseInt(sucursalActual));

	return (
		<header className="header-mobile d-block d-lg-none">
			<div className="header-mobile__bar">
				<div className="container-fluid">
					<div className="header-mobile-inner">
						<a className="logo" href={getLink("/")}>
							<img
								src="/images/icon/logo-recolector.png"
								alt="SAE Logo"
							/>
						</a>
						<div className="nombre-sucursal">
                            {/* {sucursalActualData && sucursalActualData.nombre} */}
                        </div>
						<div className="d-flex">
							<button
								onClick={abrirMenuLateral}
								className="hamburger hamburger--slider"
								type="button"
								aria-label="Abrir el menú"
							>
								<span className="hamburger-box">
									<span className="hamburger-inner"></span>
								</span>
							</button>
							<button
								onClick={() => toggleMenu()}
								className="hamburger hamburger--slider"
								type="button"
							>
								<i className="fas fa-user"></i>
								{/* <i className="fas fa-chevron-circle-down"></i> */}
							</button>
							<button
								onClick={auth.logout}
								className="btn btn-sm btn-danger ml-2"
								type="button"
								style={{ padding: "4px 8px", fontSize: "0.85rem" }}
							>
								<i className="zmdi zmdi-power"></i>
							</button>
						</div>
					</div>
				</div>
			</div>
			<nav className={"navbar-mobile " + (showMenu ? "show" : "")}>
                <div className="container-fluid p-3 bold d-flex">
                    {sucursalActualData && sucursalActualData.nombre}
                    {usuario.sucursales.length > 1 && (
                        <button type="button" className="btn btn-primary float-right" style={{marginTop: '-5px'}} onClick={toggleSucursales}>
                            <i className="zmdi zmdi-swap"></i>
                        </button>
                    )}
                </div>
				<div className="container-fluid">
					<div className="navbar-mobile__list list-unstyled">
						<div className="account-dropdown__footer">
                            <ul className="list-unstyled sucursales-dropdown-mobile" style={{display: showSucursales ? 'block' : 'none'}}>
                                {usuario.sucursales.map((sucursal) => (
                                    <li key={sucursal.id}>
                                        {/* <div className="account-dropdown__footer"> */}
                                            <button
                                                className={
                                                    parseInt(getSucursal()) ===
                                                    sucursal.id
                                                        ? "active"
                                                        : ""
                                                }
                                                onClick={() => setSucursal(sucursal.id)}
                                            >
                                                {sucursal.nombre}
                                            </button>
                                        {/* </div> */}
                                    </li>
                                ))}
                            </ul>
							<div className='account-dropdown__footer'>
                        {auth.can(permisions.verConfiguracion) && (
                            <div className='account-dropdown__item'>
                                <Link to={getLink("/configuracion")} onClick={handleConfiguracionClick}>
                                    <i className='zmdi zmdi-settings'></i>
                                    Configuración
                                </Link>

                            </div>
                        )}
                    </div>

							<button onClick={auth.logout}>
								<i className="zmdi zmdi-power"></i>Logout
							</button>
						</div>
					</div>
				</div>
			</nav>
		</header>
	);
};

export default MobileHeader;
